// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"2306ccc7","94":"614ddc29","148":"e42e16c3","332":"614ddc29","383":"9761767d","475":"614ddc29","713":"614ddc29","856":"614ddc29","951":"614ddc29"}[chunkId] + ".chunk.js";
};